function input_box(){
  // Native discount code input handling
  document.addEventListener('keydown', function(e){
    if(e.target.matches('.cd-discount-input') && e.key === 'Enter'){
      e.preventDefault();
    }
  });
  document.addEventListener('keyup', function(e){
    if(e.target.matches('.cd-discount-input')){
      var wrap = e.target.closest('.cd-discount-input-wrap');
      if(wrap){
        if(e.target.value !== ''){
          wrap.classList.add('active-input');
        } else {
          wrap.classList.remove('active-input');
        }
      }
      if(e.key === 'Enter'){
        e.preventDefault();
        var applyBtn = e.target.closest('.cd-discount-form').querySelector('.cd-discount-apply');
        if(applyBtn && !applyBtn.disabled) applyBtn.click();
      }
    }
  });
  document.addEventListener('focus', function(e){
    if(e.target.matches('.cd-discount-input')){
      var wrap = e.target.closest('.cd-discount-input-wrap');
      if(wrap) wrap.classList.add('active-focus');
    }
  }, true);
  document.addEventListener('blur', function(e){
    if(e.target.matches('.cd-discount-input')){
      var wrap = e.target.closest('.cd-discount-input-wrap');
      if(wrap) {
        var form = e.target.closest('.cd-discount-form');
        var msg = form && form.querySelector('.cd-discount-message');
        var btn = form && form.querySelector('.cd-discount-apply');
        var isLoading = btn && btn.classList.contains('loading');
        var hasError = msg && msg.classList.contains('error');
        var hasText = e.target.value !== '';
        if(!isLoading && !hasError && !hasText) {
          wrap.classList.remove('active-focus');
        }
      }
    }
  }, true);
  if(document.querySelectorAll('.menu-burdger,.close-menu')) document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
    menuBurger.addEventListener('click',function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      document.body.classList.toggle('open-menu');
      document.body.classList.remove('open-drawer','open-search','open-sort','open-filter');    
    });
  });
}
function showCartError(el,message){
  if(!el) return;
  el.textContent = message || (window.cartStrings && window.cartStrings.error) || '';
  setTimeout(function(){
    el.textContent = '';
  },3000);
}
function cartVariant(){
  document.querySelectorAll('.ci_plus a').forEach(function(plus) {
    plus.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      var input = plus.closest('.ci_qtybox').querySelector('.cart_qty');
      input.value = parseInt(input.value) + 1;
      var new_line = this.getAttribute('data-line-item');
      var new_qty = this.closest('.ci_qtybox').querySelector('.cart_qty').value;
      updateItem(new_line, new_qty);
    });
  });
  document.querySelectorAll('.ci_minus a').forEach(function(minus) {
    minus.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      var centerQtyInput = minus.closest('.ci_qtybox').querySelector('.cart_qty');
      var currentQty = parseInt(centerQtyInput.value);
      if(currentQty > 0){
        centerQtyInput.value = currentQty - 1;
        var newLine = this.getAttribute('data-line-item');
        var newQty = this.closest('.ci_qtybox').querySelector('.cart_qty').value;
        updateItem(newLine, newQty);
      }
    });
  });
  document.querySelectorAll('.inactive .cd_variant').forEach(function(cdVariantAdd) {
    cdVariantAdd.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      cdVariantAdd.closest('.cd_variant_cls').classList.remove('active');
      let cart_error = cdVariantAdd.closest('.item-row').querySelector('.cierror');
      let currentid = cdVariantAdd.closest('.item-row').querySelector('.item-remove').getAttribute('data-line');
      let changevar_id = cdVariantAdd.getAttribute('data-id');
      let item_current_qty = cdVariantAdd.closest('.item-row').querySelector('.cart_qty').value;
      let newItem = {'id': changevar_id,'quantity': item_current_qty};
      let itemProperties = cdVariantAdd.closest('.item-row').dataset.properties;
      if(itemProperties){
        try{
          let parsedProperties = JSON.parse(itemProperties);
          // cart/add.js rejects anything but a hash here.
          if(parsedProperties && !Array.isArray(parsedProperties) && Object.keys(parsedProperties).length){
            newItem.properties = parsedProperties;
          }
        }catch(err){
          console.error('Unable to carry over line item properties', err);
        }
      }
      let formData = {
        'items': [newItem]
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json',},
        body: JSON.stringify(formData),
      })
      .then((response) => response.json())
      .then((data) => {
        // Only drop the old line once the replacement is really in the cart —
        // a rejected add would otherwise leave the customer with nothing.
        if(!data || data.status){
          showCartError(cart_error, data && data.description);
          return;
        }
        setTimeout(function(e){
          updateItem(currentid,0);
        },500);
        setTimeout(function(){
          checkMultipleSizesAndTriggerPopup();
        },1200);
      })
      .catch((error) => {
        console.error('error',error);
        showCartError(cart_error);
      });
    })
  })
  // if(document.querySelectorAll(".cd_variant_cls")) document.querySelectorAll(".cd_variant_cls").forEach((variantBox) => {
  //   let btn = variantBox.querySelector(".cd_variantbtn");
  //   if(btn) btn.addEventListener("click", (e) => {
  //     e.preventDefault();
  //     e.stopImmediatePropagation();
  //     document.querySelectorAll('.item-row').forEach((variantBoxRm) => {
  //       variantBoxRm.querySelector(".cd_variant_cls").classList.remove("active");
  //     });
  //     variantBox.classList.add("active");
  //   });
  // });
  if (document.querySelectorAll(".cd_variant_cls")) {
    document.querySelectorAll(".cd_variant_cls").forEach((variantBox) => {
      let btn = variantBox.querySelector(".cd_variantbtn");
      if (btn) {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();

          document.querySelectorAll(".item-row").forEach((variantBoxRm) => {
            variantBoxRm.querySelector(".cd_variant_cls").classList.remove("active");
          });

          variantBox.classList.add("active");

          let dropdown = variantBox.querySelector(".cd__variant_list");
          let scrollParent = document.querySelector(".cd-left");

          if (dropdown && scrollParent) {
            setTimeout(() => {
              let dropdownBottom = dropdown.getBoundingClientRect().bottom;
              let parentBottom = scrollParent.getBoundingClientRect().bottom;

              if (dropdownBottom > parentBottom) {
                let scrollAmount = dropdownBottom - parentBottom + 24; // +24px offset
                scrollParent.scrollBy({
                  top: scrollAmount,
                  behavior: "smooth"
                });
              }
            }, 310);
          }
        });
      }
    });
  }

  if(document.querySelectorAll(".cd-varinat-close,.variant-overlay-box")) document.querySelectorAll(".cd-varinat-close,.variant-overlay-box").forEach((variantBoxClose) => {
    variantBoxClose.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      variantBoxClose.closest('.cart-sidebar').querySelector('.cd_variant_cls.active').classList.remove("active");
    });
  });

  if(document.querySelectorAll('.gift-product li .ellipse-icon')) document.querySelectorAll('.gift-product li .ellipse-icon').forEach((ellipse) => {
    ellipse.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      document.querySelectorAll('.gift-product li').forEach((ellipserm) => {
        ellipserm.querySelector('.gp-left').classList.remove('active-tooltip');
      });
      ellipse.closest('.gp-left').classList.add('active-tooltip');
    });
  });
  if(document.querySelectorAll('.gift-product li .tooltip p a')) document.querySelectorAll('.gift-product li .tooltip p a').forEach((ellipse_close) => {
    ellipse_close.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      ellipse_close.closest('.gp-left').classList.remove('active-tooltip');
    });
  });
  document.body.addEventListener('click', function () {
    document.querySelectorAll('.gift-product li .tooltip').forEach(function (tooltip){
      tooltip.closest('.gp-left').classList.remove('active-tooltip');
    });
  });
  announcebar({
    container: '.product-usps',
    duration: 3000
  });
  quickAddButton();
  document.querySelectorAll('.quick_view_button').forEach((quickBtn) => {
    quickBtn.addEventListener('click',function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let url = quickBtn.getAttribute('data-url');
      let modal = quickBtn.getAttribute('data-modal');
      fetch(url)
      .then((response) => response.text())
      .then((response) => {
        const html = new DOMParser().parseFromString(response, 'text/html');
        const source = html.getElementById('section-quick-buy');
        document.body.classList.add('open-quick-buy');
        document.getElementById(modal).getElementsByClassName('quick-buy-popup')[0].innerHTML = source.innerHTML;
        addToCart();
      })
      .catch((e) => {console.error(e);})
    })
  })
  document.querySelectorAll(".item-list .item-row").forEach((cItem) => {
    const id = cItem.dataset.id;
    document.querySelectorAll(".gift-product input").forEach((input) => {
      if(input.value === id){
        input.checked = true;
        togglePriceVisibility(input, true);
      }
    });
  });
  document.querySelectorAll(".gift-product input").forEach((input) => {
    input.addEventListener("change", function(e){
      if(input.checked){
        addItemNew(input.value);
        togglePriceVisibility(input, true);
      }else{
        updateItem(input.value,0);
        togglePriceVisibility(input, false);
      }
    });
  });
  function addItemNew(line){
    const data = {
      items:[{id: line,quantity: 1,},],
    };
    fetch("/cart/add.js",{
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
    .then((response) => response.json())
    .then(() => {
      if(document.location.href.indexOf('/cart') > -1) {
        window.location.href = "/cart";
      }else{
        if(typeof load_cart == 'function'){
          load_cart();
          checkMultipleSizesAndTriggerPopup();
          setTimeout(function(e){
            document.querySelector('body').classList.add('open-drawer');
          },500);
        }else{
          window.location.href = "/cart";
        }
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  }
}
// Discount code helpers
function fetchCurrentDiscountCodes() {
  return fetch('/cart.js', { method: 'GET' })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var codes = [];
      if(data.cart_level_discount_applications) {
        data.cart_level_discount_applications.forEach(function(d) {
          if(d.type === 'discount_code') codes.push(d.title);
        });
      }
      if(data.items) {
        data.items.forEach(function(item) {
          if(item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
            item.line_level_discount_allocations.forEach(function(d) {
              if(d.discount_application && d.discount_application.type === 'discount_code') {
                codes.push(d.discount_application.title);
              }
            });
          }
        });
      }
      return codes.filter(function(v, i, a) { return a.indexOf(v) === i; });
    });
}
function setDiscountLoading(loading) {
  var btn = document.querySelector('.cd-discount-apply');
  if(!btn) return;
  if(loading) {
    btn.disabled = true;
    btn.classList.add('loading');
  } else {
    btn.disabled = false;
    btn.classList.remove('loading');
  }
}
function applyDiscountCode(code) {
  fetchCurrentDiscountCodes().then(function(codes) {
    var msgEl = document.querySelector('.cd-discount-message');
    if(codes.map(function(c){return c.toLowerCase();}).indexOf(code.toLowerCase()) !== -1) {
      if(msgEl) { msgEl.textContent = 'Discount code already applied.'; msgEl.className = 'cd-discount-message error'; }
      setDiscountLoading(false);
      return;
    }
    codes.push(code);
    fetch('/checkout?discount=' + codes.map(encodeURIComponent).join(','), { method: 'GET' })
    .finally(function() {
      fetch('/cart.js', { method: 'GET' })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var applied = [];
        if(data.cart_level_discount_applications) {
          data.cart_level_discount_applications.forEach(function(d) {
            if(d.type === 'discount_code') applied.push(d.title);
          });
        }
        if(data.items) {
          data.items.forEach(function(item) {
            if(item.line_level_discount_allocations) {
              item.line_level_discount_allocations.forEach(function(d) {
                if(d.discount_application && d.discount_application.type === 'discount_code') {
                  applied.push(d.discount_application.title);
                }
              });
            }
          });
        }
        var freshMsg = document.querySelector('.cd-discount-message');
        var freshInput = document.querySelector('.cd-discount-input');
        if(applied.map(function(c){return c.toLowerCase();}).indexOf(code.toLowerCase()) === -1) {
          if(freshMsg) { freshMsg.textContent = 'Enter a valid discount code or gift card.'; freshMsg.className = 'cd-discount-message error'; }
          setDiscountLoading(false);
        } else {
          if(freshInput) freshInput.value = '';
          if(typeof load_cart === 'function') load_cart();
        }
      });
    });
  });
}
function removeDiscountCode(code) {
  var badge = document.querySelector('.cd-discount-badge[data-code="' + code + '"]') || document.querySelector('.cd-discount-remove[data-code="' + code + '"]');
  if(badge) badge.style.opacity = '0.4';
  fetchCurrentDiscountCodes().then(function(codes) {
    var remaining = codes.filter(function(c) { return c.toLowerCase() !== code.toLowerCase(); });
    fetch('/checkout?discount=' + remaining.map(encodeURIComponent).join(','), { method: 'GET' })
    .finally(function() {
      if(typeof load_cart === 'function') load_cart();
    });
  });
}
// Discount code handlers — event-delegated so they always work after DOM reloads
document.addEventListener('click', function(e) {
  var discountToggle = e.target.closest('.add_discount');
  if(discountToggle) {
    e.preventDefault();
    var wrapper = discountToggle.closest('.cd-discount-wrapper');
    if(wrapper) {
      wrapper.classList.add('active-discount');
      var inp = wrapper.querySelector('.cd-discount-input');
      if(inp) inp.focus();
    }
    return;
  }
  var applyBtn = e.target.closest('.cd-discount-apply');
  if(applyBtn) {
    e.preventDefault();
    var form = applyBtn.closest('.cd-discount-form');
    var input = form.querySelector('.cd-discount-input');
    var msgEl = form.querySelector('.cd-discount-message');
    var code = input.value.trim();
    if(msgEl) { msgEl.textContent = ''; msgEl.className = 'cd-discount-message'; }
    if(!code) {
      if(msgEl) { msgEl.textContent = 'Enter a valid discount code or gift card.'; msgEl.className = 'cd-discount-message error'; }
      return;
    }
    setDiscountLoading(true);
    applyDiscountCode(code);
    return;
  }
  var removeBtn = e.target.closest('.cd-discount-remove');
  if(removeBtn) {
    e.preventDefault();
    removeDiscountCode(removeBtn.dataset.code);
    return;
  }
});
// Helper function to get price element for gift products
function getPriceElementForInput(input) {
  // Try multiple strategies to find the price element
  const listItem = input.closest('li');
  if (!listItem) return null;
  // Primary selector
  let priceElement = listItem.querySelector('.gp-rgt');
  return priceElement;
}
// Helper function to toggle gift products price visibility
function togglePriceVisibility(input, show) {
  const priceElement = getPriceElementForInput(input);
  if (priceElement) {
    priceElement.style.display = show ? 'block' : 'none';
  } else {
    console.warn('Price element not found for input');
  }
}

// The first load_cart() call is the page load render; every later call follows a cart change
var cartDrawerRequested = false;

function load_cart(){
  var isPageLoadRender = !cartDrawerRequested;
  cartDrawerRequested = true;
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer&_=' + Date.now())
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    checkGiftPopup(isPageLoadRender);
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;      
      cartRemove.addEventListener('click',(evt) => updateItem(data_line,0));
    });
    document.querySelectorAll('.header-cart').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        document.querySelector('body').classList.toggle('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
        input_box();
      });
    });
    function overlay(){
      document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
        cartButton.addEventListener('click',function(e){
          e.preventDefault();
          e.stopImmediatePropagation();
          const createdUlElements = document.querySelectorAll('.wpp-meta-ul');
          createdUlElements.forEach(ul => ul.remove());
          if(document.querySelector('body').classList.contains('open-quick-buy') && document.querySelector('body').classList.contains('open-drawer')){
            document.querySelector('body').classList.remove('open-quick-buy','open-menu','open-search','open-sort','open-filter','open-mobile-search','filter-sticky','active-wishli-pro','open-size-chart');
          }else{
            document.querySelector('body').classList.remove('open-quick-buy','open-drawer','open-menu','open-search','open-sort','open-filter','open-mobile-search','filter-sticky','active-wishli-pro','open-size-chart');
          }
          document.querySelector('localization-form').classList.remove('active');
        });
      });
    }
    function singleCartDrawerClose() {
      const cartDrawerCloseButtons = document.querySelectorAll('.cart-drawer-close');
      if (cartDrawerCloseButtons.length > 0) {
        cartDrawerCloseButtons.forEach((cartDrawerClose) => {
          cartDrawerClose.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            const body = document.querySelector('body');
            body.classList.remove(
              'open-quick-buy',
              'open-drawer',
              'open-menu',
              'open-search',
              'open-sort',
              'open-filter',
              'open-mobile-search',
              'filter-sticky',
              'active-wishli-pro',
              'open-size-chart'
            );
            const localizationForm = document.querySelector('localization-form');
            if (localizationForm) {
              localizationForm.classList.remove('active');
            }
          });
        });
      }
    }
    if(window.innerWidth <= 991){
      if(document.querySelector('.section-contradirectional-slider') == null) overlay();
      singleCartDrawerClose();
      if(document.querySelectorAll('.menu-burdger,.close-menu')) document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
        menuBurger.addEventListener('click',function(e){
          e.preventDefault();
          e.stopImmediatePropagation();
          document.body.classList.toggle('open-menu');
          document.body.classList.remove('open-drawer','open-search','open-sort','open-filter', 'active-wishli-pro');    
        });
      });
    }else{
      overlay();
    }
    cartVariant();
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      document.querySelector('.cartlist').setAttribute('data-count',cart_count);
      document.querySelectorAll('.cart-count').forEach(function(el){
        el.textContent = '(' + cart_count + ')';
      });
    })
    .catch(function(error) {
      console.log(error);
    })
  });
}
load_cart();
/* data_line is a line item key, which stays valid when other lines are added or
   removed and is unique per line — so two lines of the same variant (gift cards
   with different recipients) can be updated independently. change.js also
   accepts a plain variant id here. */
function updateItem(data_line,data_qty){
  const data = {'id': data_line ,'quantity': data_qty };
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    if(document.location.href.indexOf('/cart') > -1) {
      window.location.href = "/cart";
    }else{
      if(typeof load_cart == 'function'){
        load_cart();
        checkMultipleSizesAndTriggerPopup();
        setTimeout(function(e){
          document.querySelector('body').classList.add('open-drawer');
        },500);
      }else{
        window.location.href = "/cart";
      }
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

document.addEventListener("input", function() {
  var cartSidebar = document.querySelector(".cart-sidebar");
  var discountInput = document.querySelector(".cd-discount-input");

  if (!cartSidebar || !discountInput) return;

  if (discountInput.value.trim() !== "") {
    cartSidebar.classList.add("has-active-discount");
  } else {
    cartSidebar.classList.remove("has-active-discount");
  }
});

document.addEventListener("DOMContentLoaded", function() {
  var cartSidebar = document.querySelector(".cart-sidebar");
  var discountBadges = document.querySelector(".cd-discount-badges");

  if (cartSidebar && discountBadges) {
    cartSidebar.classList.add("has-active-discount");
  }
});

// Cart popups (multiple sizes, gift) — only one is open at a time, the others wait for it to close
var queuedCartPopups = [];

function openCartPopup(id) {
  var overlay = document.getElementById(id);
  if (!overlay || overlay.classList.contains('is-open')) return;
  if (document.querySelector('.ms-popup-overlay.is-open')) {
    if (queuedCartPopups.indexOf(id) === -1) queuedCartPopups.push(id);
    return;
  }
  overlay.classList.add('is-open');
  overlay.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function closeCartPopup(overlay) {
  if (!overlay.classList.contains('is-open')) return;
  overlay.classList.remove('is-open');
  overlay.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
  var nextId = queuedCartPopups.shift();
  // Wait for the fade-out transition (0.3s)
  if (nextId) setTimeout(function() { openCartPopup(nextId); }, 300);
}

document.addEventListener('click', function(e) {
  var overlay = e.target.closest('.ms-popup-overlay');
  if (!overlay) return;
  if (e.target.closest('.ms-popup__close') || e.target === overlay) {
    closeCartPopup(overlay);
  }
});

document.addEventListener('keydown', function(e) {
  if (e.key !== 'Escape') return;
  var overlay = document.querySelector('.ms-popup-overlay.is-open');
  if (overlay) closeCartPopup(overlay);
});

// Gift Popup
// The cart-drawer section renders how many trigger-tagged items are in the cart and whether the
// promotion is live; load_cart calls this after every render.
let giftPopupTriggerQty = null;

function checkGiftPopup(isPageLoadRender) {
  var state = document.querySelector('.cart-sidebar [data-gift-popup-state]');
  var overlay = document.getElementById('giftPopupOverlay');
  if (!state || !overlay) return;

  // Items already in the cart on page load don't count as added. If the page load render failed,
  // there is no baseline, so count from an empty cart rather than swallowing the first add.
  var qty = parseInt(state.dataset.triggerQty, 10) || 0;
  var previousQty = giftPopupTriggerQty !== null ? giftPopupTriggerQty : (isPageLoadRender ? qty : 0);
  giftPopupTriggerQty = qty;

  if (qty <= previousQty || state.dataset.live !== 'true') return;
  if (!giftPopupAllowed(overlay)) return;
  rememberGiftPopupShown(overlay);

  // Delay to match the cart drawer open timing (500ms)
  setTimeout(function() {
    openCartPopup('giftPopupOverlay');
  }, 550);
}

// Frequency comes from theme settings. Storage keys include the promotion id, so a new promotion starts fresh.
// If storage is blocked, the popup falls back to showing on every add.
function giftPopupAllowed(overlay) {
  var id = overlay.dataset.promotionId;
  try {
    if (overlay.dataset.stopAfterClick === 'true' && localStorage.getItem('giftPopupClicked:' + id)) return false;
    switch (overlay.dataset.frequency) {
      case 'add':
        return true;
      case 'promotion':
        return !localStorage.getItem('giftPopupShown:' + id);
      case 'days':
        var shownAt = parseInt(localStorage.getItem('giftPopupShown:' + id), 10) || 0;
        var days = parseInt(overlay.dataset.frequencyDays, 10) || 1;
        return Date.now() - shownAt >= days * 86400000;
      default:
        return !sessionStorage.getItem('giftPopupShown:' + id);
    }
  } catch (e) {
    return true;
  }
}

function rememberGiftPopupShown(overlay) {
  var key = 'giftPopupShown:' + overlay.dataset.promotionId;
  var frequency = overlay.dataset.frequency;
  try {
    if (frequency === 'days' || frequency === 'promotion') {
      localStorage.setItem(key, String(Date.now()));
    } else if (frequency !== 'add') {
      sessionStorage.setItem(key, '1');
    }
  } catch (e) {}
}

document.addEventListener('click', function(e) {
  if (!e.target.closest('.gift-popup__cta')) return;
  var overlay = document.getElementById('giftPopupOverlay');
  if (!overlay || overlay.dataset.stopAfterClick !== 'true') return;
  try {
    localStorage.setItem('giftPopupClicked:' + overlay.dataset.promotionId, String(Date.now()));
  } catch (err) {}
});

// Multiple Sizes Popup
let multipleSizesPopupShown = false;

function checkMultipleSizesAndTriggerPopup() {
  if (!document.getElementById('multipleSizesOverlay')) return;
  if (multipleSizesPopupShown || sessionStorage.getItem('multipleSizesPopupShown') === 'true') return;

  fetch('/cart.js')
    .then((response) => response.json())
    .then((cartData) => {
      const productGroups = {};
      cartData.items.forEach((item) => {
        if (!productGroups[item.product_id]) {
          productGroups[item.product_id] = { variants: [], handle: item.handle };
        }
        productGroups[item.product_id].variants.push(item.variant_id);
      });

      let triggeredProductId = null;
      let triggeredHandle = null;
      Object.entries(productGroups).some(([pid, group]) => {
        if (new Set(group.variants).size >= 2) {
          triggeredProductId = pid;
          triggeredHandle = group.handle;
          return true;
        }
        return false;
      });

      if (!triggeredProductId) return;

      multipleSizesPopupShown = true;
      sessionStorage.setItem('multipleSizesPopupShown', 'true');

      // Delay to match the cart drawer open timing (500ms)
      setTimeout(function() {
        openCartPopup('multipleSizesOverlay');
      }, 550);

      // Fetch product data for EasySize in the background
      if (triggeredHandle) {
        fetch('/products/' + triggeredHandle + '.js')
          .then((r) => r.json())
          .then((product) => {
            const sizeOptionIdx = product.options.findIndex(function(o) { return (o.name || o).toLowerCase() === 'size'; });
            const optionKey = sizeOptionIdx >= 0 ? ['option1', 'option2', 'option3'][sizeOptionIdx] : 'option1';
            const product_stock = {};
            product.variants.forEach(function(v) {
              var sizeVal = v[optionKey];
              if (sizeVal) product_stock[sizeVal] = v.inventory_quantity != null ? v.inventory_quantity : 0;
            });
            window.easySizeProductData = {
              product_id: triggeredProductId,
              product_stock: product_stock
            };
            if (window._easySizeLoaded && typeof window.initEasySizePopup === 'function') {
              window.initEasySizePopup();
            } else if (typeof window.initEasySizePopup === 'function') {
              var _esPollCount = 0;
              var _esPoll = setInterval(function () {
                _esPollCount++;
                if (window._easySizeLoaded) {
                  clearInterval(_esPoll);
                  window.initEasySizePopup();
                } else if (_esPollCount >= 50) {
                  clearInterval(_esPoll);
                }
              }, 200);
            }
          })
          .catch((error) => {
            console.error('Error fetching product data for EasySize:', error);
          });
      }
    })
    .catch((error) => {
      console.error('Error checking cart for multiple sizes:', error);
    });
}
